module.exports = "../../app/cells/components/percent_bar_cell.rb";